// extracted by mini-css-extract-plugin
export default {"header":"Blog_header__BjmsQ","main":"Blog_main__6wTLL","svg":"Blog_svg__q5d9R","article":"Blog_article__hyPv6","more":"Blog_more__gSnZl","articles":"Blog_articles__Bk3EP"};